import type { FormServices } from "./formServices";
import FieldService from "./FieldService";
import type SubformId from "../state/SubformId";
import RuleService from "./RuleService";
import ValidationService from "./ValidationService";
import type { FormScope } from "../state/formVersion";
import IntegrationService from "./IntegrationService";
import VariableService from "./VariableService";
import { Scope } from "../types";

const forRootForm = (): FormServices => ({
  currentScope: Scope.ROOT,
  fieldService: FieldService.create((field) => field.scope === Scope.ROOT),
  variableService: VariableService.create(),
  ruleService: RuleService.create((rule) => rule.scope === Scope.ROOT),
  integrationService: IntegrationService.create(),
  validationService: ValidationService.create((scope) => scope === Scope.ROOT),
});
const forSubform = (subformId: SubformId): FormServices => ({
  currentScope: subformId,
  fieldService: FieldService.create((field) => subformId.equals(field.scope), subformId),
  variableService: VariableService.create(),
  ruleService: RuleService.create((rule) => subformId.equals(rule.scope), subformId),
  integrationService: IntegrationService.create(),
  validationService: ValidationService.create((scope) => subformId.equals(scope), subformId),
});

export default {
  forRootForm,
  forSubform,
  forScope: (scope: FormScope) => (scope === Scope.ROOT ? forRootForm() : forSubform(scope)),
};
